module.exports = __webpack_public_path__ + "static/media/kz.156c054b.svg";